import { render, staticRenderFns } from "./FileUploadArea.vue?vue&type=template&id=30145167&scoped=true&"
import script from "./FileUploadArea.vue?vue&type=script&lang=ts&"
export * from "./FileUploadArea.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadArea.vue?vue&type=style&index=0&id=30145167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30145167",
  null
  
)

export default component.exports